module.exports = __webpack_public_path__ + "static/insuremartusa-contact-c1b16be7f392b0b8e9729c41bc373be4.png";